var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1638 2.29186C18.4619 2.48186 14.0569 3.75186 11.8344 8.22499C9.12251 13.6844 12.1363 18.9319 12.3581 19.3025C12.1631 19.4219 7.89626 21.9469 4.10626 19.7925C1.45501 18.2856 0.766256 15.4712 0.616256 14.8562C-0.523119 10.1987 2.55438 4.78186 6.99813 2.34124C12.6081 -0.739389 18.4919 1.96874 19.1644 2.29124L19.1638 2.29186Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11127 19.7181C2.74564 20.7806 4.01127 22.5687 6.22502 24.0062C9.53689 26.1569 12.8756 26.1619 14.1281 26.1006C15.2875 26.0106 17.5344 25.6781 19.8619 24.2056C22.8225 22.3337 24.1506 19.735 24.6238 18.6712C21.98 17.0275 19.9363 16.5456 18.815 16.3775C18.3056 16.3012 17.8725 16.2731 17.3688 16.3775C15.7306 16.7175 15.0938 18.1019 14.0281 19.2194C11.5306 21.8394 7.75814 21.8637 7.54627 21.8619C5.04689 21.8425 3.12627 20.5562 2.11127 19.7181Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 7.21001C14.2406 6.48188 15.3144 5.16126 17.1456 4.20876C18.5331 3.48751 19.8125 3.25938 20.6275 3.18063C21.2244 3.60063 21.9344 4.18313 22.6337 4.97126C23.6525 6.11876 24.2612 7.26376 24.6231 8.10501C24.4019 8.21688 21.0644 9.89376 18.9031 10.2769C17.825 10.4681 17.1869 10.3113 16.7975 10.1606C16.4981 10.045 16.2456 9.89501 15.9356 9.66313C15.4194 9.27688 14.5731 8.53626 13.7306 7.20938L13.73 7.21001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIcon);
export default __webpack_public_path__ + "static/media/cc-icon.d0cf389c4c6e47cd33a75a1f73ebb8d2.svg";
export { ForwardRef as ReactComponent };